import * as React from 'react';
import type { AvatarProps } from './Avatar';
import Avatar from './Avatar';
import cn from '~modules/cn';

import './avatar-list.scss';

type Props = {
    avatars: AvatarProps[];
    maxNumber?: number;
    userLabel?: string;
    additionalUsersLabelSingular?: string;
    additionalUsersLabelPlural?: string;
    additionalTextType?: 'useInitials' | 'useCalculatedNumber';
    multipleTipDivider?: string;
    className?: string;
};

export const AvatarList = (props: Props): JSX.Element => {
    const {
        avatars,
        maxNumber = 0,
        userLabel,
        additionalUsersLabelSingular,
        additionalUsersLabelPlural,
        additionalTextType = 'useInitials',
        multipleTipDivider = ',',
        className
    } = props;
    const additionalAvatarsLength = maxNumber ? avatars.length - maxNumber : 0;
    const renderAdditionalAvatar = additionalAvatarsLength > 0;
    const additionalAvatarName = `+${additionalAvatarsLength}`;

    let additionalAvatarsTip = '';
    if (additionalTextType === 'useInitials') {
        additionalAvatarsTip = avatars
            .slice(-additionalAvatarsLength)
            .map(({ nameOrEmail }) => nameOrEmail)
            .join(`${multipleTipDivider} `);
    } else if (additionalTextType === 'useCalculatedNumber') {
        additionalAvatarsTip = `${additionalAvatarsLength}`;
    }

    const items = maxNumber ? avatars.slice(0, maxNumber) : avatars;
    const avatarSize = avatars[0]?.size;
    const additionalAvatarLabel = additionalAvatarsLength === 1 ? additionalUsersLabelSingular : additionalUsersLabelPlural;

    return (
        <div className={cn('avatar-list', className)}>
            {items.map((avatarProps: AvatarProps, index) => (
                <Avatar key={`avatar-${index}`} {...avatarProps} tipLabel={userLabel} />
            ))}
            {renderAdditionalAvatar ? (
                <Avatar
                    size={avatarSize}
                    nameOrEmail={additionalAvatarName}
                    tipLabel={additionalAvatarLabel}
                    multipleTipDivider={multipleTipDivider}
                    color="white"
                    dataTip={additionalAvatarsTip}
                    useInitials={false}
                />
            ) : null}
        </div>
    );
};

export default Avatar;
